<template>
  <div>
    <div
      class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 w-full pb-6"
    >
      <div
        class="sm:col-span-3"
        v-for="attribute in quality_group?.quality_attributes"
        :key="attribute.id"
      >
        <div class="tooltip w-max">
          <label class="label-form">
            <div class="flex justify-between">
              {{ attribute?.abbreviation || attribute?.crop_attribute?.name }}
              {{ getPercentageGeneralValueLabel(quality_group, attribute) }}
            </div>
          </label>
          <span v-if="attribute.abbreviation" class="tooltip-text">
            {{ attribute?.crop_attribute?.name }}
          </span>
        </div>
        <div class="mt-1">
          <general-value-input
            v-if="general_values && general_values[quality_group.id]"
            v-model="general_values[quality_group.id][attribute.id]"
            :quality_attribute="attribute"
            :quality_group="quality_group"
            :general_values="general_values"
          ></general-value-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralValueInput from "@/components/views/layout/quality_control/input/GeneralValueInput.vue";
import QualityGeneral from "@/components/views/layout/quality_control/mixins/quality_general.js";

export default {
  components: {
    GeneralValueInput,
  },
  mixins: [QualityGeneral],
  props: [
    "quality_template",
    "quality_group",
    "modelValue",
  ],
  data() {
    return {
      general_values: this.modelValue,
    };
  },
  computed: {},
  created() {},
  methods: {
    getPercentageGeneralValueLabel: function (group, attribute) {
      let value;
      if (this.quality_group?.calculate_percentages) {
        value = this.getPercentageGeneralValue(group, attribute);
      }
      if (value) return `(${value}%)`;
      return "";
    },
  },
  watch: {
    general_values: {
      handler: function (new_value) {
        this.$emit("update:modelValue", new_value);
      },
      deep: true,
    },
  },
};
</script>